import logoUrl from '../../public/logo.png'
import '../siteNav.css'

// Shared sticky navy header, styled identically to the homepage's nav (same
// frontend/src/siteNav.css that backend/scripts/generate_site.py also reads
// for the static pages — one source of truth, see that file's docstring).
// /plan omits the "How it works" link and the CTA: the user is already in the
// tool. Logo + wordmark link back to the homepage.
//
// The logo is imported (not referenced as a root-relative /logo.png path) so
// it resolves correctly via Vite's asset pipeline in BOTH npm run dev (where
// publicDir:false — deliberately, see vite.config.js — means frontend/public/*
// isn't served directly) and the production build.
export default function SiteNav() {
  return (
    <header className="site">
      <div className="wrap">
        <a href="/">
          <img className="logo" src={logoUrl} alt="canwego logo" />
        </a>
        <a className="brand" href="/">
          canwego
        </a>
      </div>
    </header>
  )
}
